export default __webpack_public_path__ + "static/media/promo-discount.650045e8.svg";